/**
 * Component Registry for Repli Training Theme
 * 
 * Extends the base comfy theme registry with Repli Training specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-comfy/registry';

/**
 * Repli Training specific component overrides.
 * These components have been customized for the Repli Training brand.
 * 
 * Example:
 * import { Footer } from './components/Footer';
 * 
 * const replitrainingOverrides: Partial<ComponentRegistry> = {
 *   Footer,
 * };
 */
const replitrainingOverrides: Partial<ComponentRegistry> = {
  // Add component overrides here
};

/**
 * Final merged registry for Repli Training properties.
 * Inherits all components from the comfy theme, with Repli Training overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...replitrainingOverrides,
};

export default registry;
